<template>
  <div class="events">
    <fluke-card>
      <header>
        <div class="title">Logs do sistema</div>
        <div class="description">Lista de ações dos usuários do sistema</div>
      </header>
      <main>
        <v-data-table
          :headers="headers"
          :items="list"
          :pagination.sync="pagination"
          :search="search"
          :loading="loading"
          rows-per-page-text="Linhas pos página"
          class="inner-tables"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.user }}</td>
            <td>{{ props.item.module_name_translated }}</td>
            <td>{{ props.item.module_id }}</td>
            <td>{{ props.item.action_translated }}</td>
            <td>{{ props.item.date }}</td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Sua busca por "{{ search }}" não achou nenhum resultado.
            </v-alert>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination
            v-model="page"
            :length="pages"
            color="#FEC402"
            circle
          ></v-pagination>
        </div>
      </main>
    </fluke-card>
  </div>
</template>

<script>
import axios from "axios";
import Card from "../../components/Main/Content/Card/Card.vue";
import userLogUtils from "../../helpers/user_log_utils";

export default {
  components: {
    "fluke-card": Card,
  },
  data: function () {
    return {
      loading: true,
      pages: 10,
      page: 1,
      list: [],
      pagination: {
        page: 1,
        rowsPerPage: 50,
        totalItems: 0,
      },
      headers: [
        {
          text: "Usuário",
          align: "left",
          value: "user",
        },
        {
          text: "Módulo",
          align: "left",
          value: "module_name_translated",
        },
        {
          text: "ID do Módulo",
          align: "left",
          value: "module_id",
        },
        {
          text: "Ação",
          align: "left",
          value: "action_translated",
        },
        {
          text: "Data",
          align: "left",
          value: "original_date",
        },
      ],
      search: "",
    };
  },
  mounted: function () {
    this.get();
  },
  methods: {
    get: async function () {
      this.loading = true;
      const result = await axios.get(
        this.$myServerAddresses.admin +
          `user-logs?limit=${this.pagination.rowsPerPage}&page=${this.page}`,
        {
          headers: {
            "X-Fluke": this.$cookies.get("token"),
          },
        }
      );
      this.list = result.data.list.map((elem) => {
        var newData = elem.date.slice(0, -8).split("T");
        elem.original_date = elem.date
        elem.date =
          newData[0].split("-").reverse().join("/") + " " + newData[1];
        elem.module_name_translated = userLogUtils.translateModule(
          elem.module_name
        );
        elem.action_translated = userLogUtils.translateAction(elem.action);
        return elem;
      });
      this.pages = result.data.paging.pages;
      this.pagination.totalItems = result.data.paging.count;
      this.pagination.page = result.data.paging.page;
      this.loading = false;
    },
  },
  watch: {
    page: {
      handler: function (value) {
        this.get();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
</style>


